// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c724690","453":"95768e5f","455":"e6d065ec"}[chunkId] + ".chunk.js";
};